import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const purchaseOrderItem = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("purchase-order-items"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("purchase-order-items/" + id));
    return data;
  },
  store: async (items) => {
    const { data } = await axios.post(h.baseUrl("purchase-order-items"), {
      items,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (id, qty) => {
    const { data } = await axios.put(h.baseUrl("purchase-order-items/" + id), {
      qty,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("purchase-order-items/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default purchaseOrderItem;
